import { render, staticRenderFns } from "./NotificationCenter.vue?vue&type=template&id=fef863a0&"
import script from "./NotificationCenter.vue?vue&type=script&lang=js&"
export * from "./NotificationCenter.vue?vue&type=script&lang=js&"
import style0 from "./NotificationCenter.vue?vue&type=style&index=0&id=fef863a0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports